import { Auth0Provider } from '@auth0/auth0-react';
import 'core-js';
import React from 'react';
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import App from './App';
import './polyfill';
import * as serviceWorker from './serviceWorker';

import { icons } from './assets/icons';

import { Provider } from 'react-redux';
import { store } from './redux/store';
import {
  ServerEnvironment,
  setCmsServerEnvironment
} from './reusable/CmsServerEnvironmentHelper';

React.icons = icons;

const getEnvironmentByParam = () => {
  const url = new URL(window.location.href);
  const availableEnvs = Object.keys(ServerEnvironment);

  if (url.searchParams.has('env')) {
    const selectedEnvName = url.searchParams.get('env');

    // Select the env based on the param `env`
    if (availableEnvs.includes(selectedEnvName)) {
      return ServerEnvironment[selectedEnvName];
    }
  }

  const _env = localStorage.getItem('_env');
  if (_env != null) {
    if (availableEnvs.includes(_env)) return ServerEnvironment[_env];
  }
  // if (localStorage HAS "EVN NAME"){
  //   RETURN ServerEnvironment FIND ENV NAME
  // }

  return ServerEnvironment.Production_East_Asia;
};

const selectedEnvironment = getEnvironmentByParam();
setCmsServerEnvironment(selectedEnvironment);

ReactDOM.render(
  <Auth0Provider
    domain={selectedEnvironment.auth0Domain}
    clientId={selectedEnvironment.auth0ClientId}
    audience={selectedEnvironment.auth0Audience}
    useRefreshTokens={true}
    cacheLocation='localstorage'
    redirectUri={window.location.origin + '?env=' + selectedEnvironment.name}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
